import { CommonModule } from '@angular/common'
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { NgChartsModule } from 'ng2-charts'

import { SharedModule } from '../shared/shared.module'
import { BarChartComponent } from './charts/bar-chart/bar-chart.component'
import { FeesComponent } from './components/fees/fees.component'
import { FundOptionsComponent } from './components/fund-options/fund-options.component'
import { HistoricalMeasuresComponent } from './components/historical-measures/historical-measures.component'
import { MinimumsComponent } from './components/minimums/minimums.component'
import { PerformanceAnnuallyComponent } from './components/performance-annually/performance-annually.component'
import { PerformanceCumulativeComponent } from './components/performance-cumulative/performance-cumulative.component'
import { PerformanceQuarterlyComponent } from './components/performance-quarterly/performance-quarterly.component'
import { PerformanceSummaryComponent } from './components/performance-summary/performance-summary.component'
import { QuarterlyAfterTaxComponent } from './components/quarterly-after-tax/quarterly-after-tax.component'
import { SettlementDateComponent } from './components/settlement-date/settlement-date.component'
import { TradingCutoffComponent } from './components/trading-cutoff/trading-cutoff.component'
import { PerformanceComponent } from './performance.component'

@NgModule({
  declarations: [
    PerformanceComponent,
    PerformanceQuarterlyComponent,
    PerformanceAnnuallyComponent,
    PerformanceCumulativeComponent,
    PerformanceSummaryComponent,
    QuarterlyAfterTaxComponent,
    BarChartComponent,
    FeesComponent,
    MinimumsComponent,
    HistoricalMeasuresComponent,
    FundOptionsComponent,
    TradingCutoffComponent,
    SettlementDateComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    NgChartsModule,
  ],
  exports: [PerformanceComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class PerformanceModule {}
